import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
} from "react";
import { BASEURL, HEADERS } from "components/Utils/Constants";
import client from "client";
import { useQuery } from "@apollo/client";

import { SourceContext } from "pages/SourcePage/SourcesMasterPage";
import { QUERY_fbAuthURI } from "pages/SourcePage/SourcesQueries";

// import { icons } from "pages/SourcePage/SourceList";
import { setCookie } from "helpers/Cookie";
import Heading from "components/Elements/Heading";
import { selectIcon } from "components/Utils/Utils.js";

const absolute = (uri) => {
  return `${BASEURL}${uri}`;
};

const CatalogSourceSelected = (props) => {
  const [sidebarClass, setSidebarClass] = useState(props.sidebar);
  const node = useRef();

  const { data: dataFbAuthURI } = useQuery(QUERY_fbAuthURI, {
    client,
    variables: {
      env: "PROD",
    },
  });

  const catalogData = useContext(SourceContext);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEscKey = (e) => {
    if (e.keyCode === 27) {
      setSidebarClass("sidebar close-selected");
      setTimeout(() => {
        props.closeSidebar();
      }, 600);
      setTimeout(() => {
        catalogData.enableCatalogButton();
      }, 100);
    }
  };

  const handleClickOutside = useCallback(
    (e) => {
      if (node.current && node.current.contains(e.target)) {
        return;
      } else if (
        catalogData.node &&
        catalogData.node.current.contains(e.target)
      ) {
        return;
      } else {
        setSidebarClass("sidebar close-selected");
        setTimeout(() => {
          props.closeSidebar();
        }, 600);
        setTimeout(() => {
          catalogData.enableCatalogButton();
        }, 100);
      }
    },
    [props, catalogData]
  );

  const closeHandler = (e) => {
    e.preventDefault();
    setSidebarClass("sidebar close-selected");
    setTimeout(() => {
      props.closeSidebar();
    }, 600);
    setTimeout(() => {
      catalogData.enableCatalogButton();
    }, 100);
  };

  const fetchData = async () => {
    const TOKEN = window.localStorage.token;
    // set temporarily the token in a cookie that will be used once the app is redirect from the Twitter connector and
    // needs to get authenticated without passing the User/Passord to be filled in the Login screen
    setCookie("token", TOKEN, 60);
    if (props.sourceData.type === "twitter") {
      const url = `/auth/twitter?callback=https://dashboard.pickaxe.ai/settings/sources`;
      let response = await fetch(absolute(url), {
        method: "GET",
        headers: HEADERS(TOKEN),
      });
      const data = await response.json();
      if (response) return window.location.replace(data.url);
    } else if (props.sourceData.type === "facebook") {
      const url = dataFbAuthURI.fbAuthURI.replace(
        /state%3Dgogo/g,
        "state%3D/settings/sources/" + props.sourceData.type
      );
      return window.location.replace(url);
    }
  };

  return (
    <div ref={node}>
      <div className={sidebarClass}>
        <header className="source-header p-3">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <img
                  src={selectIcon(props.sourceData.type)}
                  alt={props.sourceData.type}
                  width="40"
                  height="40"
                />
                <div>
                  <Heading size={4} className="m-2">
                    {props.sourceData.name}
                  </Heading>
                </div>
              </div>
            </div>
            <div className="col-6 py-2 text-right">
              <button
                type="button"
                className="close-selected"
                onClick={closeHandler}
              >
                &times;
              </button>
            </div>
          </div>
        </header>

        <div className="account-container p-3">
          {props.sourceData.type !== "instagram" &&
            props.sourceData.type !== "youtube" && (
              <button
                type="button"
                className="add-source-button mr-3"
                onClick={fetchData}
              >
                <i className="fas fa-plus plus-sign mr-2" />
                Connect
              </button>
            )}
          <p className=" source-content pt-2">
            Hella narwhal Cosby sweater McSweeney's, salvia kitsch before they
            sold out High Life. Umami tattooed sriracha meggings pickled Marfa
            Blue Bottle High Life next level four loko PBR. Keytar pickled next
            level keffiyeh drinking vinegar street art.
          </p>
          <p className="source-content">What Data This Gathers</p>
          <ul className="details-content">
            <li className="details-content__item">This type of thing</li>
            <li className="details-content__item">This other type of thing</li>
            <li className="details-content__item">Blah blah blah</li>
          </ul>

          <p className="source-content">About Facebook and Instagram</p>
          <p className="details-content__item">
            When you connect your Facebook accounts, you will also be given the
            abilty to connect your Instagram accounts since they are tied
            together in Facebook’s Business Accounts.
          </p>
        </div>
      </div>
    </div>
  );
};
export default CatalogSourceSelected;
